import React from 'react';
import PropTypes from 'prop-types';
// import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Typography, } from '@material-ui/core';
import { SectionHeader } from 'components/molecules';
import { CardBase } from 'components/organisms';
import { Image } from 'components/atoms';

import  Chapterpop from 'components/Popups/Chapterpop/Chapterpop';
import clsx from 'clsx';






const useStyles = makeStyles(theme => ({
  cardBase: {
    '&:hover': {
      background: '#7DEDFF',
      '& .card-icon, & .card-title': {
        color: 'white',
      },
    },
  },
  icon: {
    fontSize: 60,
    color: theme.palette.primary.main,
    [theme.breakpoints.up('sm')]: {
      fontSize: 80,
    },
  },
  title: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(6),
    },
  },

}));

const Chapterdx = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
             <CardBase >

<Image src="https://ik.imagekit.io/j6phbjneuop/New_Folder/Principal_Partner_Logos/ChapterDx__Kyu7fZkBGCI.jpg" />

</CardBase>

<br/>

      <SectionHeader
        title="Featured products"
        subtitle=" Chapter dx"
        data-aos="fade-up"
      />


      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/chapterdx_qyur3swpx0Y.png" />


            </div>

            <br />


            <Typography
              variant="h5"
              color="textPrimary"
              align="center"
              noWrap
              className={clsx(classes.title, 'card-title')}
            >
           Chapter DX

            </Typography>



            <br />
            <br />

            <Chapterpop />
          </CardBase>
        </Grid>

        <Grid item xs={12} sm={4} data-aos="fade-up">

</Grid>
<Grid item xs={12} sm={4} data-aos="fade-up">

</Grid>

      </Grid>
 

  




    </div>
  );
};

Chapterdx.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Chapterdx;
